var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendario = function SvgCalendario(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 38,
    fill: "none",
    viewBox: "0 0 30 38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendario_svg__Capa_1",
    clipPath: "url(#calendario_svg__clip0_295_865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector",
    fill: "#510C76",
    d: "M23.822 6.03H3.423C1.533 6.03 0 7.58 0 9.496v25.032c0 1.914 1.533 3.466 3.423 3.466h20.399c1.89 0 3.423-1.552 3.423-3.466V9.496c0-1.915-1.533-3.466-3.423-3.466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_2",
    fill: "white",
    d: "M26.577 2.807H6.178c-1.89 0-3.423 1.552-3.423 3.466v25.033c0 1.914 1.533 3.466 3.423 3.466h20.399c1.89 0 3.423-1.552 3.423-3.466V6.273c0-1.914-1.533-3.466-3.423-3.466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_3",
    fill: "#510C76",
    d: "M6.178 2.807h20.393C28.464 2.807 30 4.362 30 6.28V9.24H2.755V6.28c0-1.917 1.536-3.472 3.429-3.472z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendario_svg__Group",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_4",
    d: "M9.027 0H9.02a1.15 1.15 0 0 0-1.143 1.157v3.68c0 .639.512 1.157 1.143 1.157h.006a1.15 1.15 0 0 0 1.143-1.157v-3.68A1.15 1.15 0 0 0 9.027 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_5",
    d: "M23.728 0h-.006a1.15 1.15 0 0 0-1.143 1.157v3.68c0 .639.512 1.157 1.143 1.157h.006a1.15 1.15 0 0 0 1.143-1.157v-3.68A1.15 1.15 0 0 0 23.728 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "calendario_svg__Group_2",
    fill: "#510C76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_6",
    d: "M8.775 15.264c.764 0 1.383-.627 1.383-1.4 0-.774-.619-1.401-1.383-1.401s-1.383.627-1.383 1.4c0 .774.619 1.401 1.383 1.401"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_7",
    d: "M13.845 15.264c.764 0 1.384-.627 1.384-1.4 0-.774-.62-1.401-1.384-1.401s-1.383.627-1.383 1.4c0 .774.62 1.401 1.383 1.401"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_8",
    d: "M18.91 15.264c.764 0 1.383-.627 1.383-1.4 0-.774-.62-1.401-1.383-1.401-.764 0-1.384.627-1.384 1.4 0 .774.62 1.401 1.384 1.401"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_9",
    d: "M23.974 15.264c.764 0 1.384-.627 1.384-1.4 0-.774-.62-1.401-1.384-1.401s-1.383.627-1.383 1.4c0 .774.62 1.401 1.383 1.401"
  })), /*#__PURE__*/React.createElement("g", {
    id: "calendario_svg__Group_3",
    fill: "#510C76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_10",
    d: "M8.775 20.237c.764 0 1.383-.627 1.383-1.4 0-.774-.619-1.4-1.383-1.4s-1.383.626-1.383 1.4.619 1.4 1.383 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_11",
    d: "M13.845 20.237c.764 0 1.384-.627 1.384-1.4 0-.774-.62-1.4-1.384-1.4s-1.383.626-1.383 1.4.62 1.4 1.383 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_12",
    d: "M18.91 20.237c.764 0 1.383-.627 1.383-1.4 0-.774-.62-1.4-1.383-1.4-.764 0-1.384.626-1.384 1.4s.62 1.4 1.384 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_13",
    d: "M23.974 20.237c.764 0 1.384-.627 1.384-1.4 0-.774-.62-1.4-1.384-1.4s-1.383.626-1.383 1.4.62 1.4 1.383 1.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "calendario_svg__Group_4",
    fill: "#510C76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_14",
    d: "M8.775 25.21c.764 0 1.383-.626 1.383-1.4s-.619-1.4-1.383-1.4-1.383.627-1.383 1.4c0 .774.619 1.4 1.383 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_15",
    d: "M13.845 25.21c.764 0 1.384-.626 1.384-1.4s-.62-1.4-1.384-1.4-1.383.627-1.383 1.4c0 .774.62 1.4 1.383 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_16",
    d: "M18.91 25.21c.764 0 1.383-.626 1.383-1.4s-.62-1.4-1.383-1.4c-.764 0-1.384.627-1.384 1.4 0 .774.62 1.4 1.384 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_17",
    d: "M23.974 25.21c.764 0 1.384-.626 1.384-1.4s-.62-1.4-1.384-1.4-1.383.627-1.383 1.4c0 .774.62 1.4 1.383 1.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "calendario_svg__Group_5",
    fill: "#510C76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_18",
    d: "M8.775 30.184c.764 0 1.383-.627 1.383-1.4 0-.774-.619-1.401-1.383-1.401s-1.383.627-1.383 1.4c0 .774.619 1.401 1.383 1.401"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_19",
    d: "M13.845 30.184c.764 0 1.384-.627 1.384-1.4 0-.774-.62-1.401-1.384-1.401s-1.383.627-1.383 1.4c0 .774.62 1.401 1.383 1.401"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_20",
    d: "M18.91 30.184c.764 0 1.383-.627 1.383-1.4 0-.774-.62-1.401-1.383-1.401-.764 0-1.384.627-1.384 1.4 0 .774.62 1.401 1.384 1.401"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendario_svg__Vector_21",
    d: "M23.974 30.184c.764 0 1.384-.627 1.384-1.4 0-.774-.62-1.401-1.384-1.401s-1.383.627-1.383 1.4c0 .774.62 1.401 1.383 1.401"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendario_svg__clip0_295_865"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h30v38H0z"
  })))));
};
export default SvgCalendario;